export default "__VITE_ASSET__4a4a69a4__"